import React, { useEffect, useState } from 'react';
import { useLocation, useRoutes } from 'react-router-dom';
import router from 'src/router';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import { CssBaseline } from '@mui/material';
import ThemeProvider from './theme/ThemeProvider';
import { Navigate } from 'react-router-dom';
import Login from './components/Login/Login';
import './index.css'; // Import your global styles
//test

export const PUBLIC_APP_PATHS = [
  '/',
  '/forgot-password',
  '/company-application',
  '/company-invitation',
  '/worker-application-signing',
  '/quote/quoteTemplate',
  '/quote/invoiceTemplate',
  /^\/quoteForClient\/[^/]+$/,
  /^\/invoiceForClient\/[^/]+$/,
  /^\/actualsForClient\/[^/]+$/
];

export const isPublicAppPath = (pathname: string) =>
  PUBLIC_APP_PATHS.some((path) =>
    typeof path === 'string' ? pathname === path : path.test(pathname)
  );

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const location = useLocation(); // To get current pathname

  const content = useRoutes(router);

  useEffect(() => {
    // Check if PLS is in local storage
    const user = localStorage.getItem('PLS');

    if (user) {
      // If PLS is found, set isLoggedIn to true
      setIsLoggedIn(true);
    }
  }, []);

  const isPublicPath = isPublicAppPath(location.pathname);

  return (
    <ThemeProvider>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <CssBaseline />
        {isLoggedIn || isPublicPath ? content : <Login />}
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
